import React, { Component } from 'react';
import logo from '../images/logo.svg';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { firebase } from '../firebase';
import { auth } from '../firebase';

require('./index.css');

class SignupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      passwordOne: '',
      passwordTwo: '',
      error: null,
      isChecked: false
    }
  }

  handleEmailChange = (event) => {
    this.setState({
      email: event.target.value
    });
  }

  handlePasswordOneChange = (event) => {
    this.setState({
      passwordOne: event.target.value
    });
  }

  handlePasswordTwoChange = (event) => {
    this.setState({
      passwordTwo: event.target.value
    });
  }

  handleCheckChange = (event) => {
    this.setState({
      isChecked: !this.state.isChecked
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const {
      email,
      passwordOne,
      isChecked,
    } = this.state;

    const user = email.replace(/[.#$@]/g, "");
    
    if (!isChecked) {
      this.setState({
        error: { 
          message:'Please agree to our Terms, Conditions, and Privacy Policy before signing up'
        }
      });
    } else {
        auth.doCreateUserWithEmailAndPassword(email, passwordOne)
        .then(authUser => {
          this.setState({ 
            email: '',
            passwordOne: '',
            passwordTwo: '',
            error: null 
          });
          firebase.database.ref('users/' + user).set(true);
          this.props.push('/home');      
        })
        .catch(error => {
          this.setState({
            error: error
          });
        });
      }
    }

  render() {
    const {
      email,
      passwordOne,
      passwordTwo,
      error,
    } = this.state;

    const isInvalid = 
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      email === '';

    return (
        <div className='card text-white bg-primary mb-3'>
            <div className='card-header'>
              <div>
                <img src={logo} className='login-logo' alt='nerve-logo' />
                  NeuroSchematic &nbsp;
                <i className='fa fa-registered'></i>
              </div>
              <div>Sign Up</div>
            </div>
            <div className='card-body'>
                <form onSubmit={ this.handleSubmit }>

                  <div className='form-group'>
                    <label htmlFor='email'>Email</label>
                    <input 
                      type='email' 
                      className='form-control' 
                      id='email' 
                      aria-describedby='emailHelp' 
                      placeholder='Enter Email' 
                      value={ email }
                      onChange={ this.handleEmailChange } />
                    <small id='emailHelp' className='form-text' style={{ color: '#fff' }}>
                      We will never share your information with anyone else.
                    </small>
                  </div>

                  <div className='form-group'>
                    <label htmlFor='passWord'>Password</label>
                    <input 
                      type='password' 
                      className='form-control' 
                      id='passWord' 
                      placeholder='Enter Password' 
                      value={ passwordOne }
                      onChange={ this.handlePasswordOneChange } />
                    <input 
                      type='password' 
                      className='form-control' 
                      placeholder='Confirm Password' 
                      value={ passwordTwo }
                      onChange={ this.handlePasswordTwoChange } 
                      style={{ marginTop: 30 }}/>
                  </div>
                  
                  <h6>Already have an account? &nbsp; <a href='/login'>LOG IN</a></h6>
                  <input
                    name='isChecked'
                    type='checkbox'
                    checked={this.state.isChecked}
                    onChange={this.handleCheckChange} 
                    style={{ float: 'left', marginTop: 6, transform: 'scale(1.3)' }}/>
                    <p style={{ marginLeft: 25 }}>I agree to the <a href='http://www.neuroschematic.com/terms-conditions/' target='_blank' rel='noopener noreferrer'>Terms, Conditions,</a> and <a href='http://www.neuroschematic.com/privacy-policy/' target='_blank' rel='noopener noreferrer'>Privacy Policy.</a></p>
                    <button disabled={isInvalid} type='submit' className='btn btn-secondary'>
                    Sign Up
                  </button>
                  { error && <p style={{ color: '#f46b42'}}>{error.message}</p> }
                </form>
            </div>
              <h5 style={{ textAlign: 'center', marginBottom: 30 }}>Neuroschematic is best viewed on desktop or laptop screens</h5>
        </div>
    );
  }
}

//-----Redux Functions-----
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ push }, dispatch); 
};

export default connect(null, mapDispatchToProps)(SignupForm);


// WEBPACK FOOTER //
// ./src/signup/index.js